import lang from "translations";
import { Path } from "paths";
import InvoicedSvg from "assets/svg/Invoiced";

const navItems = (access, connectedSiigo = false, showMdm = null, isPouchVenue = false, beachFlowIntegration = false) => {
  let items = [
    {
      to: Path.SLASH,
      text: lang.dashboard,
      icon: "dashboard2",
      exact: true,
    },    
    {
      to: Path.PRODUCT,
      text: lang.selling,
      icon: "shirt",
      items: [
        {
          to: Path.PRODUCT,
          text: lang.products,
        },
        {
          to: Path.CATEGORY,
          text: lang.productCategories,
        },
      ],
    },
    {
      to: Path.INVENTORY,
      text: lang.inventory,
      icon: "inventory",
      items: [
        {
          to: Path.INVENTORY_SUPPLY_ITEM,
          text: lang.supplyItems,
        },
        {
          to: Path.INVENTORY_STOCKTAKE,
          text: lang.stocktake,
        },
      ],
    },
    {
      to: Path.SIIGO_INVOICES,
      text: lang.eInvoice,
      IconComponent: InvoicedSvg,
      hide: !connectedSiigo,
      items: [
        {
          to: Path.SIIGO_REFUND_VOUCHER_REPORT,
          text: lang.refundVoucher
        }, {
          to: Path.SIIGO_VOUCHER_TOPUP_REPORT,
          text: lang.topupVoucher
        },
        {
          to: Path.SIIGO_ADJUSTMENT_VOUCHER_REPORT,
          text: lang.adjustmentVoucher
        }
      ],
    },
    {
      to: Path.LOCATION,
      text: lang.locations,
      icon: "vendor2",
      items: [
        {
          to: Path.LOCATION,
          text: lang.locations,
        },
        {
          to: Path.LOCATION_KDS,
          text: "KDS",
          hide: !beachFlowIntegration,
        },
      ],
    },
    {
      to: Path.RESOURCE_MANAGEMENT,
      text: lang.resourceManagement,
      icon: "folder1",
      items: [
        {
          to: Path.RESOURCE,
          text: lang.resource,
        },
        {
          to: Path.SECTION,
          text: lang.section,
        },
        {
          to: Path.RESOURCETYPE,
          text: lang.resourceTypes,
        },
        {
          to: Path.RESOURCE_INSIGHTS,
          text: lang.resourceInsights,
        },
      ],
    },
    {
      to: Path.BOOKING,
      text: lang.bookings,
      icon: "bookings",
      items: [
        {
          to: Path.CANCELATION_REPORT_NAV,
          text: "Cancelation Tickets",
        },
      ],
    },
    {
      to: Path.MULTI_PROPERTY,
      text: lang.multiProperty,
      icon: "building",
      items: [
        {
          to: Path.MULTI_PROPERTY_BALANCE_MOVEMENT_IN,
          text: lang.balanceMovementsIn,
        },
        {
          to: Path.MULTI_PROPERTY_BALANCE_MOVEMENT_OUT,
          text: lang.balanceMovementsOut,
        },
      ],
    },
    {
      to: Path.STAFF,
      text: lang.staff,
      icon: "staff",
      items: [
        {
          to: Path.STAFF,
          text: lang.staff,
        },
        // {
        //   to: Path.STAFF_PROFILE,
        //   text: lang.staffProfile,
        // },
      ],
    },
    {
      to: Path.GUEST,
      text: lang.guests,
      icon: "guest",
      items: [
        {
          to: Path.GUESTS,
          text: lang.guests,
        },
        {
          to: Path.GUEST_PROFILE,
          text: lang.guestProfile,
        },
      ],
    },
    {
      to: Path.VOUCHER,
      text: lang.vouchers,
      icon: "voucher",
    },
    {
      to: Path.DISCOUNT,
      text: lang.discounts,
      icon: "discount",
    },
    {
      to: Path.TRANSACTION,
      text: lang.transactions,
      icon: "transactions",
      items: [
        {
          to: Path.TRANSACTION,
          text: lang.allTransactions,
        },
        {
          to: Path.REGISTER_REPORT,
          text: lang.registerReports,
        },
        {
          to: Path.END_OF_DAY_REPORT,
          text: lang.endOfDayReports,
        },
        {
          to: Path.ORDER_KPI,
          text: lang.orderKpi,
        }

      ],
    },
    {
      to: Path.REPORT,
      text: lang.reports,
      icon: "document",
      items: [
        {
          to: Path.REPORT_INVENTORY,
          text: lang.inventoryReport,
        },
        {
          to: Path.REPORT_SALES,
          text: lang.salesReport,
        },
        {
          to: Path.REPORT_CATEGORY,
          text: lang.categoryReport,
        },
        {
          to: Path.REPORT_TIP,
          text: lang.tipReport,
        },
        {
          to: Path.REPORT_ADDITIONAL_CHARGE,
          text: lang.additionalChargeReport,
        },
        {
          to: Path.REPORT_DISCOUNT,
          text: lang.discountReport,
        },
        {
          to: Path.REPORT_VOUCHER,
          text: lang.voucherReport,
        },
        {
          to: Path.REPORT_FREE_CREDITS,
          text: lang.freeCreditsReport,
        },
        {
          to: Path.REPORT_ACCESS_CONTROL,
          text: lang.accessControlReport,
        },
        {
          to: Path.REPORT_ON_GROUND,
          text: lang.onGround,
        },
        {
          to: Path.REPORT_GUEST_REFUND,
          text: lang.guestRefundReport,
        },
        {
          to: Path.REPORT_REFUND_CLAIM,
          text: lang.refundClaimReport,
        },
        {
          to: Path.UNSYNC_TRANSACTION,
          text: lang.unsyncTransactionReports,
        },
        {
          to: Path.MONTHLY_SALE_REPORT,
          text: lang.monthlySaleReport,
          hide: !isPouchVenue
        },
      ],
    },
    {
      to: Path.DEVICE,
      text: lang.devices,
      icon: "devices",
      items: [
        {
          to: Path.DEVICES,
          text: lang.devices,
        },
        {
          to: Path.DEVICE_SYNC_STATUS,
          text: lang.deviceSyncStatus,
        },
        {
          to: Path.PRINTER,
          text: lang.printers,
        },
      ],
    },
    {
      to: Path.MDM,
      text: lang.mdm,
      icon: "devices",
      hide: !showMdm,
      items: [
        {
          to: Path.MDM,
          text: lang.mdm,
        },
        {
          to: Path.DEVICE_GEO_LOCATION,
          text: lang.deviceGeoLocation,
        }
      ],
    },
    {
      to: Path.SETTING,
      text: lang.settings,
      icon: "gear",
    },
    {
      to: Path.PRE_AUTH_TRANSACTION_LIST,
      text: lang.preAuthTransaction,
      icon: "transactions",
    },
    {
      to: Path.RESERVATION_LIST,
      text: lang.reservations,
      icon: "bookings",
    },
  ];
  items = filterItems(items);
  if (!access.length) {
    return items;
  }
  return items
    .filter((item) => {
      return access.includes(item.to);
    })
    .map((item) => {
      if (item.items?.length) {
        return {
          ...item,
          items: item.items.filter((sub) => {
            return access.includes(sub.to);
          }),
        };
      }
      return item;
    });
};

const filterItems = (items) => {
  return items
    .filter((item) => !item.hide) // Filter out items with `hide: true`
    .map((item) => {
      if (item.items?.length) {
        // Recursively filter nested items
        return {
          ...item,
          items: filterItems(item.items),
        };
      }
      return item;
    })
    .filter((item) => !item.items || item.items.length > 0); // Remove items with empty `items` arrays
};

export default navItems;
